export const positionTypesBySport = {
    football: ['Goal keeper', 'Defender', 'Forward', 'Midfielder', 'Utility'],
    'rugby league': ['Full back', 'Centres', 'Halves', 'Wings', 'Front row', 'Back Row', 'Utility'],
    'rugby union': ['Full back', 'Centres', 'Halves', 'Wings', 'Front Row', 'Back Row', 'Locks', 'Utility']
};
//# sourceMappingURL=index.js.map